import { create } from 'zustand';
import { produce } from 'immer';

export interface PrintModeSlice {
  isPrintMode: boolean;
  setPrintMode: (printMode: boolean) => void;
}

const usePrintStore = create<PrintModeSlice>((set) => ({
  isPrintMode: false,
  setPrintMode: (printMode) =>
    set(
      produce((state: PrintModeSlice) => {
        state.isPrintMode = printMode;
      })
    ),
}));

export default usePrintStore;
